var _rect, _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _rect2, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgCommon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 667,
    viewBox: "0 0 375 667",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_179_93734)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 667,
    fill: "#D2E3F1"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_179_93734",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -25,
    y: 0,
    width: 428,
    height: 648
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M402.596 0H-24.3232V647.21H402.596V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_179_93734)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.596 0H-24.3232V647.21H402.596V0Z",
    fill: "#D2E3F1"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2847 476.671V461.27H13.3566V476.671H6.84522V471.987H-0.761728V465.644H-5.34441V471.987H-10.8838V457.362H-16.562V471.987H-21.1292V476.671H-31.8993V578.411H26.9041V476.671H20.2847Z",
    fill: "#A5C6E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M66.0344 447.157V444.381H63.2724H54.6162V440.937H48.5523V436.905H45.0805V440.937H41.2076V429.383H37.7359V440.937H31.2245V444.381H26.9041H24.1267V447.157H26.9041V449.669H24.1267V452.445H26.9041V454.958H24.1267V457.749H26.9041V460.246H24.1267V463.038H26.9041V465.535H24.1267V468.327H26.9041V470.824H24.1267V473.615H26.9041V578.411H63.2724V494.77H66.0344V491.994H63.2724V489.481H66.0344V486.705H63.2724V484.193H66.0344V481.417H63.2724V478.904H66.0344V476.128H63.2724V473.615H66.0344V470.824H63.2724V468.327H66.0344V465.535H63.2724V463.038H66.0344V460.246H63.2724V457.749H66.0344V454.958H63.2724V452.445H66.0344V449.669H63.2724V447.157H66.0344Z",
    fill: "#A5C6E3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7832 494.941V491.994H91.0617V476.717H88.4386V491.994H84.3497V487.031H76.3878V491.994H72.9315V494.941H63.2724V594.712H100.844V494.941H95.7832Z",
    fill: "#A5C6E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.776 474.841V472.22H137.614V474.841H132.63V458.478H129.714V474.841H124.591V470.824H118.913V467.536H114.268V470.824H110.55V463.038H106.584V470.824H103.946V474.841H100.844V607.662H151.161V474.841H145.776Z",
    fill: "#A5C6E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M191.171 487.031V483.123H184.567V480.16H178.734V483.123H174.738V470.824H171.544V483.123H167.81V487.031H163.382V480.067H158.521V487.031H151.161V613.137H206.323V487.031H191.171Z",
    fill: "#A5C6E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M234.02 511.396V507.906H229.591V498.57H227.092V507.906H223.497V504.975H219.608V507.906H216.615V511.396H206.323V621.667H237.831V511.396H234.02Z",
    fill: "#A5C6E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M290.524 456.803H285.124V454.306H280.279V447.622H277.1V454.306H270.589V456.803H265.327V436.455H262.411V456.803H256.455V451.236H248.416V444.551H245.654V451.236H241.905V456.803H235.686V460.572H237.831V625.637H288.75V460.572H290.524V456.803Z",
    fill: "#A5C6E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M333.605 494.941V487.574H326.954V494.941H320.582V490.226H315.737V485.914H311.725V490.226H307.435V478.671H301.896V490.226H297.036V494.941H288.75V618.937H339.067V494.941H333.605Z",
    fill: "#A5C6E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M359.372 472.406V469.056H355.777V458.696H352.305V469.056H348.818V472.406H344.683V465.163H340.394V472.406H339.067V570.192H379.678V472.406H359.372Z",
    fill: "#A5C6E3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 598.053,
    width: 377.256,
    height: 72.5012,
    fill: "#B1C2E3"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M5.76512 525.866V520.469H0.966422V525.866H-5.0821V516.917H-10.1277V502.974H-15.1733V516.917H-21.4841V525.866H-31.8993V614.812H14.1744V525.866H5.76512Z",
    fill: "#77AAD4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M54.6162 508.651V505.766H51.7463H39.3252V501.703H33.5698V497.531H30.993V501.703H26.9041V489.032H23.1701V501.703H19.3898V505.766H14.1744V617.557H51.7463V535.668H54.6162V532.783H51.7463V530.255H54.6162V527.37H51.7463V524.858H54.6162V521.973H51.7463V519.445H54.6162V516.561H51.7463V514.048H54.6162V511.163H51.7463V508.651H54.6162Z",
    fill: "#77AAD4"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8722 535.001V521.973H92.0492V535.001H85.6921V530.255H81.1557V516.917H77.9154V530.255H73.1321V525.866H67.0682V530.255H63.2724V535.001H51.7463V623.342H110.55V535.001H99.8722Z",
    fill: "#77AAD4"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M154.355 554.496V542.926H145.699V554.496H140.237V549.859H126.01V535.001H122.323V549.859H118.789V554.496H110.55V631.267H165.712V554.496H154.355Z",
    fill: "#77AAD4"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209.07 525.866V504.246H201.787V525.866H194.72V519.445H187.406V509.83H180.848V519.445H174.244V525.866H165.712V631.267H216.615V525.866H209.07Z",
    fill: "#77AAD4"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M268.645 542.926V507.286H265.358V542.926H258.307V536.707H252.505V527.836H246.194V536.707H237.831V517.941H233.079V536.707H225.503V542.926H216.615V638.277H277.841V542.926H268.645Z",
    fill: "#77AAD4"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M312.543 566.082V561.553H310.521V541.251H306.988V561.553H302.698V555.721H291.851V561.553H286.296V566.082H277.841V640.107H331.784V566.082H312.543Z",
    fill: "#77AAD4"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M323.652 549.859H317.959V573.216H323.652V549.859Z",
    fill: "#77AAD4"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M356.95 529.526V523.136H348.818V511.396H344.575V523.136H337.261V529.526H331.784V640.107H377.256V529.526H356.95Z",
    fill: "#77AAD4"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M25.5926 603.552V585.468H17.7696V603.552H6.38233V594.712H-0.37597V590.602H-2.5053V594.712H-8.86242V574.1H-13.8771V594.712H-20.6354V603.552H-34.3218V684.572H33.5698V603.552H25.5926Z",
    fill: "#4A8DC6"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M77.8537 554.496V541.251H71.8052V554.496H63.2724V547.3H51.9006V538.723H47.2716V547.3H40.5133V554.496H29.1414V558.467H33.5698V684.572H85.6921V558.467H89.2255V554.496H77.8537Z",
    fill: "#4A8DC6"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M134.744 585.871V554.496H129.405V585.871H121.582V579.171H118.388V574.1H115.703V579.171H108.791V566.531H103.807V579.171H99.1933V585.871H85.6921V684.572H145.699V585.871H134.744Z",
    fill: "#4A8DC6"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M168.551 621.512V607.662H156.423V621.512H145.699V684.572H178.441V621.512H168.551Z",
    fill: "#4A8DC6"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M231.798 570.036V565.849H218.652V570.036H211.168V561.661H200.151V549.859H194.118V561.661H189.134V570.036H178.441H174.244V574.255H178.441V579.854H174.244V584.072H178.441V589.671H174.244V593.89H178.441V599.488H174.244V603.707H178.441V609.306H174.244V613.524H178.441V619.139H174.244V623.342H178.441V684.572H243.895V570.036H231.798Z",
    fill: "#4A8DC6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M292.252 596.852V581.963H283.72V596.852H270.558V590.602H263.29V579.171H257.041V590.602H249.589V596.852H243.895V687.628H300.878V596.852H292.252Z",
    fill: "#4A8DC6"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M365.498 613.292V594.712H348.818V613.292H334.916V605.553H331.784V600.543H328.158V605.553H321.754V591.78H313.901V605.553H308.608V613.292H300.878V690.062H377.256V613.292H365.498Z",
    fill: "#4A8DC6"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86136 607.662H-18.3364V611.648H1.86136V607.662Z",
    fill: "#1D71B8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1415 607.662H8.9437V611.648H29.1415V607.662Z",
    fill: "#1D71B8"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86136 614.812H-18.3364V618.798H1.86136V614.812Z",
    fill: "#1D71B8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1415 614.812H8.9437V618.798H29.1415V614.812Z",
    fill: "#1D71B8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86136 621.977H-18.3364V625.963H1.86136V621.977Z",
    fill: "#1D71B8"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1415 621.977H8.9437V625.963H29.1415V621.977Z",
    fill: "#1D71B8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86136 629.142H-18.3364V633.128H1.86136V629.142Z",
    fill: "#1D71B8"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1415 629.142H8.9437V633.128H29.1415V629.142Z",
    fill: "#1D71B8"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86136 636.292H-18.3364V640.278H1.86136V636.292Z",
    fill: "#1D71B8"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1415 636.292H8.9437V640.278H29.1415V636.292Z",
    fill: "#1D71B8"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M1.86136 643.457H-18.3364V647.443H1.86136V643.457Z",
    fill: "#1D71B8"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1415 643.457H8.9437V647.443H29.1415V643.457Z",
    fill: "#1D71B8"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 560.266H38.4457V562.313H81.1557V560.266Z",
    fill: "#1D71B8"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 564.577H38.4457V566.624H81.1557V564.577Z",
    fill: "#1D71B8"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 568.889H38.4457V570.936H81.1557V568.889Z",
    fill: "#1D71B8"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 573.2H38.4457V575.248H81.1557V573.2Z",
    fill: "#1D71B8"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 577.512H38.4457V579.559H81.1557V577.512Z",
    fill: "#1D71B8"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 581.823H38.4457V583.871H81.1557V581.823Z",
    fill: "#1D71B8"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 586.12H38.4457V588.167H81.1557V586.12Z",
    fill: "#1D71B8"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 590.431H38.4457V592.478H81.1557V590.431Z",
    fill: "#1D71B8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 594.743H38.4457V596.79H81.1557V594.743Z",
    fill: "#1D71B8"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 599.054H38.4457V601.101H81.1557V599.054Z",
    fill: "#1D71B8"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 603.366H38.4457V605.413H81.1557V603.366Z",
    fill: "#1D71B8"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 607.677H38.4457V609.725H81.1557V607.677Z",
    fill: "#1D71B8"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 611.989H38.4457V614.036H81.1557V611.989Z",
    fill: "#1D71B8"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 616.301H38.4457V618.348H81.1557V616.301Z",
    fill: "#1D71B8"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 620.612H38.4457V622.659H81.1557V620.612Z",
    fill: "#1D71B8"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 624.924H38.4457V626.971H81.1557V624.924Z",
    fill: "#1D71B8"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 629.235H38.4457V631.282H81.1557V629.235Z",
    fill: "#1D71B8"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 633.547H38.4457V635.594H81.1557V633.547Z",
    fill: "#1D71B8"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 637.858H38.4457V639.906H81.1557V637.858Z",
    fill: "#1D71B8"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 642.154H38.4457V644.202H81.1557V642.154Z",
    fill: "#1D71B8"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M81.1557 646.466H38.4457V648.513H81.1557V646.466Z",
    fill: "#1D71B8"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1785 592.494H89.2255V608.716H94.1785V592.494Z",
    fill: "#1D71B8"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M103.328 592.494H98.3755V608.716H103.328V592.494Z",
    fill: "#1D71B8"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M112.463 592.494H107.51V608.716H112.463V592.494Z",
    fill: "#1D71B8"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M121.597 592.494H116.644V608.716H121.597V592.494Z",
    fill: "#1D71B8"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M130.732 592.494H125.779V608.716H130.732V592.494Z",
    fill: "#1D71B8"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M139.867 592.494H134.914V608.716H139.867V592.494Z",
    fill: "#1D71B8"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1785 612.501H89.2255V628.723H94.1785V612.501Z",
    fill: "#1D71B8"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M103.328 612.501H98.3755V628.723H103.328V612.501Z",
    fill: "#1D71B8"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M112.463 612.501H107.51V628.723H112.463V612.501Z",
    fill: "#1D71B8"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M121.597 612.501H116.644V628.723H121.597V612.501Z",
    fill: "#1D71B8"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M130.732 612.501H125.779V628.723H130.732V612.501Z",
    fill: "#1D71B8"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M139.867 612.501H134.914V628.723H139.867V612.501Z",
    fill: "#1D71B8"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M94.1785 632.508H89.2255V648.73H94.1785V632.508Z",
    fill: "#1D71B8"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M103.328 632.508H98.3755V648.73H103.328V632.508Z",
    fill: "#1D71B8"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M112.463 632.508H107.51V648.73H112.463V632.508Z",
    fill: "#1D71B8"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M121.597 632.508H116.644V648.73H121.597V632.508Z",
    fill: "#1D71B8"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M130.732 632.508H125.779V648.73H130.732V632.508Z",
    fill: "#1D71B8"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M139.867 632.508H134.914V648.73H139.867V632.508Z",
    fill: "#1D71B8"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M153.63 626.971H149.34V631.282H153.63V626.971Z",
    fill: "#1D71B8"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M160.573 626.971H156.284V631.282H160.573V626.971Z",
    fill: "#1D71B8"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M167.517 626.971H163.227V631.282H167.517V626.971Z",
    fill: "#1D71B8"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M174.46 626.971H170.171V631.282H174.46V626.971Z",
    fill: "#1D71B8"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M153.63 633.438H149.34V637.75H153.63V633.438Z",
    fill: "#1D71B8"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M160.573 633.438H156.284V637.75H160.573V633.438Z",
    fill: "#1D71B8"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M167.517 633.438H163.227V637.75H167.517V633.438Z",
    fill: "#1D71B8"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M174.46 633.438H170.171V637.75H174.46V633.438Z",
    fill: "#1D71B8"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M153.63 639.906H149.34V644.217H153.63V639.906Z",
    fill: "#1D71B8"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M160.573 639.906H156.284V644.217H160.573V639.906Z",
    fill: "#1D71B8"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M167.517 639.906H163.227V644.217H167.517V639.906Z",
    fill: "#1D71B8"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M174.46 639.906H170.171V644.217H174.46V639.906Z",
    fill: "#1D71B8"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M153.63 646.373H149.34V650.685H153.63V646.373Z",
    fill: "#1D71B8"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M160.573 646.373H156.284V650.685H160.573V646.373Z",
    fill: "#1D71B8"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M167.517 646.373H163.227V650.685H167.517V646.373Z",
    fill: "#1D71B8"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M174.46 646.373H170.171V650.685H174.46V646.373Z",
    fill: "#1D71B8"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M184.444 573.2H182.607V654.888H184.444V573.2Z",
    fill: "#1D71B8"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M188.733 573.2H186.897V654.888H188.733V573.2Z",
    fill: "#1D71B8"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M193.023 573.2H191.186V654.888H193.023V573.2Z",
    fill: "#1D71B8"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M197.312 573.2H195.476V654.888H197.312V573.2Z",
    fill: "#1D71B8"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M201.602 573.2H199.765V654.888H201.602V573.2Z",
    fill: "#1D71B8"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 573.2H205.274V575.248H219.979V573.2Z",
    fill: "#1D71B8"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 573.2H224.16V575.248H238.865V573.2Z",
    fill: "#1D71B8"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 577.512H205.274V579.559H219.979V577.512Z",
    fill: "#1D71B8"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 577.512H224.16V579.559H238.865V577.512Z",
    fill: "#1D71B8"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 581.823H205.274V583.871H219.979V581.823Z",
    fill: "#1D71B8"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 581.823H224.16V583.871H238.865V581.823Z",
    fill: "#1D71B8"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 586.12H205.274V588.167H219.979V586.12Z",
    fill: "#1D71B8"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 586.12H224.16V588.167H238.865V586.12Z",
    fill: "#1D71B8"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 590.431H205.274V592.478H219.979V590.431Z",
    fill: "#1D71B8"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 590.431H224.16V592.478H238.865V590.431Z",
    fill: "#1D71B8"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 594.743H205.274V596.79H219.979V594.743Z",
    fill: "#1D71B8"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 594.743H224.16V596.79H238.865V594.743Z",
    fill: "#1D71B8"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 599.054H205.274V601.101H219.979V599.054Z",
    fill: "#1D71B8"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 599.054H224.16V601.101H238.865V599.054Z",
    fill: "#1D71B8"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 603.366H205.274V605.413H219.979V603.366Z",
    fill: "#1D71B8"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 603.366H224.16V605.413H238.865V603.366Z",
    fill: "#1D71B8"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 607.677H205.274V609.725H219.979V607.677Z",
    fill: "#1D71B8"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 607.677H224.16V609.725H238.865V607.677Z",
    fill: "#1D71B8"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 611.989H205.274V614.036H219.979V611.989Z",
    fill: "#1D71B8"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 611.989H224.16V614.036H238.865V611.989Z",
    fill: "#1D71B8"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 616.301H205.274V618.348H219.979V616.301Z",
    fill: "#1D71B8"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 616.301H224.16V618.348H238.865V616.301Z",
    fill: "#1D71B8"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 620.612H205.274V622.659H219.979V620.612Z",
    fill: "#1D71B8"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 620.612H224.16V622.659H238.865V620.612Z",
    fill: "#1D71B8"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 624.924H205.274V626.971H219.979V624.924Z",
    fill: "#1D71B8"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 624.924H224.16V626.971H238.865V624.924Z",
    fill: "#1D71B8"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 629.235H205.274V631.282H219.979V629.235Z",
    fill: "#1D71B8"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 629.235H224.16V631.282H238.865V629.235Z",
    fill: "#1D71B8"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 633.547H205.274V635.594H219.979V633.547Z",
    fill: "#1D71B8"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 633.547H224.16V635.594H238.865V633.547Z",
    fill: "#1D71B8"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 637.858H205.274V639.906H219.979V637.858Z",
    fill: "#1D71B8"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 637.858H224.16V639.906H238.865V637.858Z",
    fill: "#1D71B8"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 642.154H205.274V644.202H219.979V642.154Z",
    fill: "#1D71B8"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 642.154H224.16V644.202H238.865V642.154Z",
    fill: "#1D71B8"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M219.979 646.466H205.274V648.513H219.979V646.466Z",
    fill: "#1D71B8"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M238.865 646.466H224.16V648.513H238.865V646.466Z",
    fill: "#1D71B8"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M254.788 602.373H248.57V614.036H254.788V602.373Z",
    fill: "#1D71B8"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M264.772 602.373H258.553V614.036H264.772V602.373Z",
    fill: "#1D71B8"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M274.755 602.373H268.536V614.036H274.755V602.373Z",
    fill: "#1D71B8"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M284.738 602.373H278.52V614.036H284.738V602.373Z",
    fill: "#1D71B8"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M294.721 602.373H288.503V614.036H294.721V602.373Z",
    fill: "#1D71B8"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M254.788 616.828H248.57V628.491H254.788V616.828Z",
    fill: "#1D71B8"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M264.772 616.828H258.553V628.491H264.772V616.828Z",
    fill: "#1D71B8"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M274.755 616.828H268.536V628.491H274.755V616.828Z",
    fill: "#1D71B8"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M284.738 616.828H278.52V628.491H284.738V616.828Z",
    fill: "#1D71B8"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M294.721 616.828H288.503V628.491H294.721V616.828Z",
    fill: "#1D71B8"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M254.788 631.282H248.57V642.945H254.788V631.282Z",
    fill: "#1D71B8"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M264.772 631.282H258.553V642.945H264.772V631.282Z",
    fill: "#1D71B8"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M274.755 631.282H268.536V642.945H274.755V631.282Z",
    fill: "#1D71B8"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M284.738 631.282H278.52V642.945H284.738V631.282Z",
    fill: "#1D71B8"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M294.721 631.282H288.503V642.945H294.721V631.282Z",
    fill: "#1D71B8"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M254.788 645.737H248.57V657.4H254.788V645.737Z",
    fill: "#1D71B8"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M264.772 645.737H258.553V657.4H264.772V645.737Z",
    fill: "#1D71B8"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M274.755 645.737H268.536V657.4H274.755V645.737Z",
    fill: "#1D71B8"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M284.738 645.737H278.52V657.4H284.738V645.737Z",
    fill: "#1D71B8"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M294.721 645.737H288.503V657.4H294.721V645.737Z",
    fill: "#1D71B8"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M319.363 618.348H306.263V625.947H319.363V618.348Z",
    fill: "#1D71B8"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M338.341 618.348H325.241V625.947H338.341V618.348Z",
    fill: "#1D71B8"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M357.32 618.348H344.22V625.947H357.32V618.348Z",
    fill: "#1D71B8"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M319.363 628.491H306.263V636.09H319.363V628.491Z",
    fill: "#1D71B8"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M338.341 628.491H325.241V636.09H338.341V628.491Z",
    fill: "#1D71B8"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M357.32 628.491H344.22V636.09H357.32V628.491Z",
    fill: "#1D71B8"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M319.363 638.634H306.263V646.233H319.363V638.634Z",
    fill: "#1D71B8"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M338.341 638.634H325.241V646.233H338.341V638.634Z",
    fill: "#1D71B8"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M357.32 638.634H344.22V646.233H357.32V638.634Z",
    fill: "#1D71B8"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgCommon);
export default __webpack_public_path__ + "static/media/bgCommon.ef77986958767b4c512f689faeea0032.svg";
export { ForwardRef as ReactComponent };